import { HttpClient, HttpParams } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { Component, Input, OnInit } from '@angular/core';
import { ColumnSortService } from 'src/app/components/dynamic-data-list/services/column-sort.service';
import { ProtoList } from 'src/app/components/pages-partials/card-list/proto-list';

@Component({
    selector: 'data-list-lazyload',
    templateUrl: './card-list.component.html',
    styleUrls: ['./card-list.component.scss'],
    providers: [ColumnSortService],
    standalone: false
})
export class CardListLazyloadComponent extends ProtoList<any> implements OnInit {

    @Input() sourceUrl: string;
    @Input() queryParams: HttpParams;

    constructor(
        private http: HttpClient,
        private sortService: ColumnSortService
    ) {
        super();
    }
    ngOnInit(): void {
        this.setTitles(this.cellProps);
        this.loadData();
        this.sortService.sortColumn$.subscribe(sortEvent => this.items = this.sortItems(this.items, sortEvent));
    }

    public getDisplayItems(): any[] {
        return this.items;
    }

    public paginationChanged(event: any) {
        this.loadData(event);
    }

    protected selectAllInView() {
        let selectedRows = new Set<any>([...this.selectedItems, ...this.items]);
        this.selectedItems = [...selectedRows];
    }

    private async loadData(page: number = 1) {
        this.isLoading = true;
        let loaded = [];
        let loadedTotal = 0;
        if (!!this.sourceUrl) {
            try {
                let params = (this.queryParams || new HttpParams())
                    .set('page', page.toString())
                    .set('perpage', this.pageSize.toString())

                let resp = await firstValueFrom(this.http.get<any[]>(this.sourceUrl, { observe: 'response', params }), { defaultValue: undefined });
                loadedTotal = (Number(resp.headers.get('x-total-count')) || resp.body?.length) ?? 0;
                loaded = resp.body || [];
            } catch (err) {
                console.warn(err);
            }
        }
        this.totalItems = loadedTotal;
        this.items = loaded;
        this.isLoading = false;
    }

}